import { defineStore } from 'pinia'
import { ProgramCategoryRecord, ProgramProductRecord } from '~/types/generated'
import { InquiryFormData } from '~/types/inquiry'

export const useInquiryStore = defineStore('InquiryStore', {
  state: () => ({
    preselectedCategory: {} as ProgramCategoryRecord,
    preselectedProduct: {} as ProgramProductRecord,
    activeStep: 1,
    categories: [] as ProgramCategoryRecord[],
    products: [] as ProgramProductRecord[]
  }),
  getters: {
    getProductsByCategory(state) {
      return (categoryName: string) => state.products.filter(product => product.category?.programCategory === categoryName)
    }
  },
  actions: {
    setActiveStep(step: number) {
      this.activeStep = step
    },
    setFormData(data: InquiryFormData) {
      this.formData.push(data)
    },
    setPreselectedCategory(category: ProgramCategoryRecord) {
      this.preselectedCategory = category
    },
    setPreselectedProduct(product: ProgramProductRecord) {
      this.preselectedProduct = product
    },
    async skipToStep(category: ProgramCategoryRecord, product: ProgramProductRecord) {
      const { $i18n } = useNuxtApp()

      this.setPreselectedCategory(category)
      this.setPreselectedProduct(product)
      this.setActiveStep(2)
      await $i18n.locale.value === 'en' ? navigateTo('/en/inquiry') : navigateTo('/povprasevanje')
    },
    async fetchCategories(locale: string) {
      const { data } = await useAsyncGql('programCategories', {
        // @ts-ignore
        locale,
        options: {
          initialCache: false
        }
      })

      this.categories = data.value.allProgramCategories
    },
    async fetchProducts(locale: string) {
      const { data } = await useAsyncGql('programProducts', {
        // @ts-ignore
        locale,
        options: {
          initialCache: false
        }
      })

      this.products = data.value.allProgramProducts
    }
  }
})
